import React, { useState } from "react";
import { useNavigate } from "@reach/router";

import Button from "../components/Button";
import TextField from "../components/TextField";

import logo from "../assets/logo.svg";
import { useAuth } from "../context/AuthContext";
import { useModal } from "../context/ModalContext";

import { ReactComponent as Envelope } from "../assets/icons/envelope.svg";
import { ReactComponent as Lock } from "../assets/icons/lock.svg";
import { ReactComponent as Eye } from "../assets/icons/eye.svg";

const Login = () => {
  const { showModal } = useModal();
  const { authenticate } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async () => {
    if (email && password) {
      try {
        await authenticate(email, password);
        navigate("/", { replace: true });
      } catch (error) {
        console.log(error);
        showModal(error, "warn");
      }
    }
  };

  return (
    <div className="bg-[url('assets/bg.jpg')] bg-cover h-screen">
      <div className="absolute right-0 w-80 p-10 h-screen flex flex-col items-center bg-black opacity-80">
        <img className="mt-0 h-32" src={logo} alt="logo" />
        <div className="mt-10 text-white font-bold text-xl">Administrativo</div>
        <form className="mt-4 flex flex-col w-full">
          <TextField
            value={email}
            update={setEmail}
            label="E-mail"
            Icon={Envelope}
          />
          <TextField
            value={password}
            update={setPassword}
            id="password"
            label="Senha"
            type={showPassword ? "text" : "password"}
            Icon={Lock}
            ActionIcon={() => (
              <button onClick={() => setShowPassword((p) => !p)}>
                <Eye />
              </button>
            )}
          />
          <Button className="mt-9" onClick={handleLogin}>
            Entrar
          </Button>
        </form>
        <div className="text-white grow font-sans flex items-end">
          © 2024 Mystra Tecnologia
        </div>
      </div>
    </div>
  );
};

export default Login;
